import "./approvalworkflowprofile.scss";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Dropdown, Table } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import threedotvertical from "../../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../../assets/images/delete-icon.svg";
import duplicatePlusIcon from "../../../assets/images/duplicate-plus-icon.svg";
import useApprovalWorkflow from "../../../Hooks/useApprovalWorkflow";
import { useAppSelector } from "../../../redux/hooks";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import Loading from "../../../components/LoadingPage/Loading";
import { toggleClass } from "../../../utils/commonUtils";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import { CommonDuplicateModel } from "../../../components/commonDuplicateModel/duplicateModel";
import { ApprovalWorkflow } from "../../../redux/approvalWorkflow/approvalWorkflowSlice";

const ApprovalWorkflowProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const currentUserId = useAppSelector(selectCurrentUserId);
  const {
    getApprovalWorkflowByIdAPI,
    getApprovalWorkflowByIdLoading,
    deleteApprovalWorkflowAPI,
    deleteApprovalWorkflowLoading,
    duplicateApprovalWorkflowAPI,
    duplicateApprovalWorkflowLoading,
  } = useApprovalWorkflow();

  const [workflowData, setWorkflowData] = useState<ApprovalWorkflow | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  useEffect(() => {
    if (id) {
      getApprovalWorkflowByIdAPI(id)
        .then((res: any) => setWorkflowData(res))
        .catch(() => navigate("/approval-workflow-master"));
    } else {
      navigate("/approval-workflow-master");
    }
  }, []);

  useEffect(() => {
    console.log("@@@WorkflowData", workflowData);
  }, [workflowData]);

  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };

  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };

  const deleteWorkflow = async () => {
    await deleteApprovalWorkflowAPI({
      id: workflowData?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleModal();
    navigate("/approval-workflow-master");
  };

  const duplicateWorkflow = async () => {
    await duplicateApprovalWorkflowAPI({
      id: workflowData?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleDuplicateModal();
    navigate("/approval-workflow-master");
  };

  const isLoading =
    getApprovalWorkflowByIdLoading ||
    deleteApprovalWorkflowLoading ||
    duplicateApprovalWorkflowLoading;

  if (!workflowData && !isLoading) return null;

  return (
    <div className="profile-page-wrapper approval-workflow-profile-main">
      {isLoading && <Loading />}
      <div className="approval-workflow-profile-header">
        <div className="profile-title-status-box">
          <h2>{workflowData?.workflowName || "-"}</h2>
          <div
            className={`status-box ${workflowData?.isActive ? "active" : "inactive"}`}
          >
            <span className="status-circle"></span>
            <span className="status-text">
              {workflowData?.isActive ? "Active" : "Inactive"}
            </span>
          </div>
        </div>
        <div className="profile-actions-box">
          <div className="edit-btn-box">
            <Button
              variant="primary"
              onClick={() => navigate(`/edit-approval-workflow/${id}`)}
            >
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
          <Dropdown>
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={toggleModal}>
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={deleteicon}
                />
                Delete
              </Dropdown.Item>
              <Dropdown.Item onClick={toggleDuplicateModal}>
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={duplicatePlusIcon}
                />
                Duplicate
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="profile-detail-box-wrapper">
        <div className="profile-detail-box">
          <div className="profile-info-box">
            <label>Module Name</label>
            <p>{workflowData?.moduleName || "-"}</p>
          </div>
          <div className="profile-info-box">
            <label>Workflow Name</label>
            <p>{workflowData?.workflowName || "-"}</p>
          </div>
          <div className="profile-info-box">
            <label>Approval Mode</label>
            <p>{workflowData?.approvalMode?.mode || "-"}</p>
          </div>
          <div className="profile-info-box">
            <label>Active</label>
            <p>{workflowData?.isActive ? "Yes" : "No"}</p>
          </div>
        </div>
        <div className="approver-details-table-wrapper">
          <label>Approver Details</label>
          <Table responsive="md" hover={false}>
            <thead>
              <tr>
                <th>#</th>
                <th>Username</th>
                <th>Email</th>
                <th>Approval Order</th>
              </tr>
            </thead>
            <tbody>
              {workflowData?.approverDetails && workflowData.approverDetails.length > 0 ? (
                workflowData.approverDetails.map((approver, index) => (
                  <tr key={approver.approverUserId}>
                    <td>{index + 1}</td>
                    <td>{approver.user?.userName || "-"}</td>
                    <td>{approver.user?.email || "-"}</td>
                    <td>{approver.approvalOrder}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">No approvers added</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteWorkflow}
        recordName={workflowData?.workflowName || ""}
        modelName={`approval workflow`}
        isDeletePermitted={true}
      />
      <CommonDuplicateModel
        showDuplicateModal={showDuplicateModal}
        toggleDuplicateModal={toggleDuplicateModal}
        modelName={`approval workflow`}
        recordName={workflowData?.workflowName || ""}
        duplicate={duplicateWorkflow}
        isDuplicatePermitted={true}
      />
    </div>
  );
};

export default ApprovalWorkflowProfile;
